module.exports = __webpack_public_path__ + "img/banner-square.6e1ce6c9.png";